import { getCliffTimeRemaining } from "@/utils";
import { useEffect, useState } from "react";

const UnlockCountdown = () => {
  const [timeLeft, setTimeLeft] = useState(getCliffTimeRemaining());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getCliffTimeRemaining());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  return (
    <span>
      {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m
    </span>
  );
};

export default UnlockCountdown;
